(function () {
	const imagebanner = () => {
		const paralax = document.querySelector(".image-banner");
    if ( paralax.classList.contains("slider_started")) {
      return;
    }
    paralax.classList.add("slider_started");
		const section = document.querySelector('.image-banner');
		const img = document.querySelector('.image-banner__img');


	};
	(function () {
    const initParallax = (selector, options = {}) => {
        document.querySelectorAll(selector).forEach((element) => {
            $(element).jarallax(options);
        });
    };

    const initializeAllParallax = () => {
        initParallax('.jarallax');

        initParallax('.jarallax-video');
    };


    document.addEventListener("shopify:section:load", initializeAllParallax);

    
    window.addEventListener("load", initializeAllParallax);
})();
	
	imagebanner();

	document.addEventListener("shopify:section:load", function () {
		imagebanner();
	});
})();
